import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FrustrationMethodSection() {
  const benefits = ['Vuelve a comer pan, pizza y dulces sin gluten… sin inflamación y sin fallar en el intento', 'Resultados esponjosos, con sabor real y sin picos de azúcar', 'Resultados desde el primer intento sin desperdiciar ingredientes ni dinero', 'Ingredientes accesibles que puedes conseguir fácilmente'];
  return <section className="py-10 md:py-14 px-4 bg-[#FFFBEB]" data-id="element-146">
      <div className="max-w-xl mx-auto" data-id="element-147">
        {/* Headline */}
        <div className="text-center mb-6" data-id="element-148">
          <span className="inline-block text-[13px] font-bold text-[#D9A441] uppercase tracking-widest mb-2" data-id="element-149">
            La solución
          </span>
          <h2 className="text-[18px] md:text-[22px] font-black text-gray-900 font-[Merriweather,_serif] leading-snug" data-id="element-150">
            Por eso creé un sistema simple que te permite lograrlo{' '}
            <span className="text-[#D9A441]" data-id="element-151">desde el primer intento</span>
          </h2>
        </div>

        {/* Benefit List */}
        <div className="space-y-3" data-id="element-152">
          {benefits.map((benefit, index) => <div key={index} className="bg-white border border-[#E8F5E9] rounded-lg px-4 py-3.5 flex items-start gap-3" data-id="element-153">
              <CheckCircle2 className="w-5 h-5 text-[#22C55E] flex-shrink-0 mt-0.5" data-id="element-154" />
              <p className="text-[15px] md:text-base text-gray-800 font-medium leading-snug" data-id="element-155">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}